// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-identitypickerdropdown-textField {
  min-width: 270px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.bolt-identity-picker-clearButton {
  padding: 4px;
  cursor: pointer;
}
.bolt-identity-picker-clearButton:hover {
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}

@media screen and (max-width: 599px) {
  .bolt-identitypicker-filterbaritem {
    min-width: 200px;
  }
}
.bolt-identitypicker-filterbaritem {
  background-color: transparent;
  border: 1px solid transparent;
}

/*# sourceMappingURL=IdentityPickerDropdown.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/IdentityPickerDropdown/IdentityPickerDropdown.scss","webpack://./../azure-devops-ui/bin/Components/IdentityPickerDropdown/IdentityPickerDropdown.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAMA;EACI,gBAJW;EAKX,gBAPuB;EAQvB,mBARuB;ACG3B;;ADQA;EACI,YEwSQ;EFtSR,eAAA;ACNJ;ADQI;EACI,qCE+GU;EDrHhB,kEAAkE;AACpE;;AAEA;EACE;IACE,gBAAgB;EAClB;ADIF;ACFA;EDOI,6BAAA;ECLF,6BAA6B;AAC/B;;AAEA,qDAAqD","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
